import { render, staticRenderFns } from "./CentersTypesEdit.vue?vue&type=template&id=c63fc712&scoped=true&"
import script from "./CentersTypesEdit.vue?vue&type=script&lang=js&"
export * from "./CentersTypesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63fc712",
  null
  
)

export default component.exports